<div class="d-flex card" *ngIf="eGiftVenue">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Gift Card Setup</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideCancel]="true"
				[hideDelete]="true"
				[saveDisabled]="!changesToSave"
				(onSaveChange)="onSave()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'cogs']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Setup</div>
			</ng-template>
			<app-e-gift-setup [eGiftVenue]="eGiftVenue" [(changesToSave)]="changesToSave"></app-e-gift-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'sack']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Denominations</div>
			</ng-template>
			<app-e-gift-card-denomination-setup [denominations]="eGiftVenue.EGiftDenomination" [eGiftVenue]="eGiftVenue"></app-e-gift-card-denomination-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'donate']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Promos</div>
			</ng-template>
			<app-e-gift-promo-code-setup [eGiftVenue]="eGiftVenue"></app-e-gift-promo-code-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'gift-card']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Pool</div>
			</ng-template>
			<app-e-gift-card-pool-setup [eGiftVenue]="eGiftVenue"></app-e-gift-card-pool-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" [disabled]="!walletPreferences">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['fab', 'apple']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Apple Wallet</div>
			</ng-template>
			<app-gift-card-apple-wallet-setup
				#giftCardAppleWalletSetupComponent
				*ngIf="walletPreferences"
				[(changesToSave)]="changesToSave"
				[(walletPreferences)]="walletPreferences"
			></app-gift-card-apple-wallet-setup>
		</p-tabPanel>
	</p-tabView>
</div>

<p-card *ngIf="displayGiftSetup || (venueService.ooVenue && !venueService.ooVenue.giftProcessor)">
	<h4>A Gift Processor must be specified for EGift Services to work. Please configure a Gift Processor.</h4>
</p-card>

<p-dialog *ngIf="venueService.ooVenue" header="Setup FocusLink Gift Account" [(visible)]="displayGiftSetup" [closable]="false">
	<div class="d-flex flex-column">
		<div class="mb-3">
			<p-dropdown [(ngModel)]="transientGift.processor" [options]="giftProcessors" [style]="{ width: '100%' }"></p-dropdown>
		</div>
		<div>
			<span>Api Key</span>
		</div>
		<div class="mb-3">
			<input [disabled]="transientGift.processor === 2" pInputText class="w-100" type="text" [(ngModel)]="transientGift.apiKey" />
		</div>
		<div>
			<span>Api Secret</span>
		</div>
		<div class="mb-3">
			<input [disabled]="transientGift.processor === 2" pInputText class="w-100" type="text" [(ngModel)]="transientGift.apiSecret" />
		</div>
		<div>
			<span *ngIf="transientGift.processor === 2">API Key & API Secret is not require for Focus CA Gift.</span>
		</div>
	</div>
	<p-footer>
		<p-button pRipple styleClass=" p-button-raised p-button-danger m-2" (click)="displayGiftSetup = false; eGiftVenue = undefined">
			<ng-template pTemplate="content">
				<fa-icon [icon]="['far', 'window-close']" size="lg" class="ms-1"></fa-icon>
			</ng-template>
		</p-button>
		<p-button pRipple styleClass=" p-button-raised p-button-success m-2" (click)="saveGiftSettings()" [disabled]="!transientGift.processor">
			<ng-template pTemplate="content">
				<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1"></fa-icon>
			</ng-template>
		</p-button>
	</p-footer>
</p-dialog>
